import { applyMiddleware, createStore } from 'redux';
import thunk from 'redux-thunk';

import reducers, { initialState } from './reducers';

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
//@ts-ignore
export const ChatStore = createStore(reducers, initialState, applyMiddleware(thunk));
